module.exports = __webpack_public_path__ + "img/shop-process2.c410a2db.png";